// Position in Add New User is free text, optional, up to 100 characters (DV-39).
export const USER_POSITION_MAX_LENGTH = 100;

// i18n key of the limit error (users.json); the schema carries the key, the form translates it.
export const USER_POSITION_TOO_LONG_KEY = "users.form.positionTooLong";

/** Spaces around the position are cut; an empty value becomes undefined and is not sent. */
export const normalizeUserPosition = (
  value?: string | null,
): string | undefined => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

/** Copy of the payload with a trimmed `position`, or without the key when it is empty. */
export const withNormalizedPosition = <T extends { position?: string }>(
  payload: T,
): T => {
  const { position, ...rest } = payload;
  const normalized = normalizeUserPosition(position);
  return (normalized ? { ...rest, position: normalized } : rest) as T;
};
